import React from "react";
function Confirm()
{
    return (
        <div className="container margin-top mb-5">
        <h2 className="text-center mb-4 fw-bold pb-2 pt-3 mt-5">Confirm</h2>
        <p className="fs-5 p-5 text-center">Thanks for confirming your email. My team will be contact you as soon as possible!</p>
        </div>
    )
}
export default Confirm;